const lockers = new Set();

window.lockScroll = (locker) => {
  lockers.add(locker);
  document.documentElement.style.overflow = "hidden";
};

window.unlockScroll = (locker) => {
  lockers.delete(locker);

  if (!lockers.size) {
    document.documentElement.style.overflow = null;
  }
};
